import { ReactNode } from 'react';

import { OnboardingPlanDisplay } from '../../../../types';

export interface CellData {
  asset?: ReactNode;
  text?: string;
  check?: boolean;
}

interface RowData {
  key: RowKey;
  isNew?: boolean;
  isComing?: boolean;
  getCellData: (plan: OnboardingPlanDisplay) => CellData;
}

export interface SectionData {
  key: SectionKey;
  rows: RowData[];
}

export enum SectionKey {
  BankAndPayment = 'bank-and-payment',
  SpendManagement = 'spend-management',
  SimplifiedComptability = 'simplified-comptability',
  Billing = 'billing',
  SupportAndInsurance = 'support-and-insurance',
}

export enum RowKey {
  PhysicalCards,
  VirtualCards,
  Transfers,
  WithdrawalMonth,
  BulkTransfers,
  MaximumPaymentMonth,
  MaximumWithdrawalMonth,
  SwiftTransfer,
  CheckDepositMonth,
  CashDepositMonth,
  AccessManagement,
  CardsManagement,
  Settings,
  SingleUsageCard,
  AccountantAccess,
  Receipts,
  AccountantExports,
  AccountantSoftwareIntegration,
  BillingTool,
  AutoReminder,
  InstantPayment,
  PaymentTerminal,
  OnlineSupport,
  PhoneSupport,
  LegalAssistance,
  AccidentInsurance,
  MobileInsurance,
  WarrantyExtension,
  ContractLibrary,
  ToolBox,
  PartnerNetwork,
  RecoveryAssistance,
  ComputerInsurance,
}
